import { render, staticRenderFns } from "./BrandMaterialsBox.vue?vue&type=template&id=0c970646&scoped=true&"
import script from "./BrandMaterialsBox.vue?vue&type=script&lang=ts&"
export * from "./BrandMaterialsBox.vue?vue&type=script&lang=ts&"
import style0 from "./BrandMaterialsBox.vue?vue&type=style&index=0&id=0c970646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c970646",
  null
  
)

export default component.exports